<template lang="pug">
  .branding
    .col1
      Logo(:brand="brand")
    .col2
      span Sponsored by
      Logo(:brand="sponsor")
    .col3.in
      router-link(:to="{name: 'home'}")
        TransitionLogo
      MenuButton.menubutton(@click.native="toggleMenuAct", :class="{ 'is-active': config.menu }")

</template>
<script>
import { mapState, mapActions } from 'vuex'
import Logo from '@/components/Logo'
import TransitionLogo from '@/components/transition/TransitionLogo'
import MenuButton from '@/components/MenuButton'

export default {
  data(){
    return {
      menuactive: false
    }
  },
  components: {
    Logo,
    TransitionLogo,
    MenuButton
  },
  props: {
    brand: {
      type: Object
    },
    sponsor: {
      type: Object
    },
    lab: {
      type: Object
    },
  },
  computed: {
    ...mapState([
      'config'
    ])
  },
  methods: {
    ...mapActions([
      'toggleMenu'
    ]),
    toggleMenuAct() {
      this.toggleMenu()
    }
  }
}
</script>
<style lang="scss" scoped>
  .in{
    display: flex;
  }
  .menubutton{
    position: relative;
    z-index: 11;
  }

  .branding{
    display: grid;
    align-items: center;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1rem;
    padding: 0.5rem 1rem;
    font-family: 'Open Sans', sans-serif;
    position: relative;
    color: white;
    max-width: 100vw;
    @media (max-width: 800px){
      grid-gap: 10px;
    }
    .col1{
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .col2{
      display: flex;
      justify-content: center;
      align-items: center;
      span{
        @media (max-width: 800px){
          font-size: 10px;
        }
      }
    }
    .col3{
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    @media (max-width: 500px){
      grid-template-columns: repeat(2, 1fr);
      .col1{
        display: none;
      }
    }
    &:before{
      content: '';
      left: 0;
      right: 0;
      top: 0;
      position: absolute;
      z-index: -1;
      height: 10vh;
      background: linear-gradient(rgba(black, 0.6), transparent );
    }
    span{
      font-size: 12px;
      line-height: 12px;
      padding-right: 2px;
      text-align: right;
    }
  }
</style>
